import { render, staticRenderFns } from "./UserCardRightsAdmin.vue?vue&type=template&id=023a7f58&scoped=true&"
import script from "./UserCardRightsAdmin.vue?vue&type=script&lang=ts&"
export * from "./UserCardRightsAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a7f58",
  null
  
)

export default component.exports